import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function nextPage({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        d="M6 12l-.707.707L4.586 12l.707-.707L6 12zm12-1a1 1 0 110 2v-2zm-8.707 5.707l-4-4 1.414-1.414 4 4-1.414 1.414zm-4-5.414l4-4 1.414 1.414-4 4-1.414-1.414zM6 11h12v2H6v-2z"
      ></path>
    </svg>
  );
}

export default nextPage;
